import { DIALOG_ACTION_TYPE, IDepartmentCache, IDialogProps } from './DialogContext';
import { IListItem } from './type';

export const setDepartmentCacheState = (context: IDialogProps, eName: string | null, department: IDepartmentCache) => {
    const dispatch = context.dispatch;

    dispatch({
        type: DIALOG_ACTION_TYPE.SET_CACHE,
        payload: {
            departmentCache: department,
            enterpriseName: eName,
        },
    });
};

export const setSugState = (context: IDialogProps, result: IListItem[][]) => {
    const dispatch = context.dispatch;
    const [departmentList, memberList] = result;
    dispatch({
        type: DIALOG_ACTION_TYPE.SET_DATASUG,
        payload: {
            memberList,
            departmentList,
            isSearchMode: true,
        },
    });
};

/**
 * @description 全选按钮展示
 */
export const onSellectChange = (context: IDialogProps, isChecked: boolean, otherParams: { [key: string]: any }) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.SET_ALL_LIST_CHECKED,
        payload: {
            isChecked,
            otherParams,
        },
    });
};

export const cleanSelectedState = (context: IDialogProps, otherParams?: { [key: string]: any }) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.CLEAN_SELECTED,
        payload: {
            otherParams,
        },
    });
};

export const setCleanState = (context: IDialogProps) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.CLEAN,
        payload: {},
    });
};

export const setSelectedList = (context: IDialogProps, list: IListItem[]) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.SET_SELECTED_LIST,
        payload: {
            list,
        },
    });
};

export const setMemberSelectedMap = (context: IDialogProps, list: IListItem[]) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.SET_MEMBER_SELECTED_MAP,
        payload: {
            list,
        },
    });
};

export const setDepartmentSelectedMap = (context: IDialogProps, list: IListItem[]) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.SET_DEPARTMENT_SELECTED_MAP,
        payload: {
            list,
        },
    });
};

export const setCleanDataList = (context: IDialogProps) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.CLEAN_DATA_LIST,
        payload: {},
    });
};

export const setIsSearchMode = (context: IDialogProps, value: boolean) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.SET_IS_SEARCH_MODE,
        payload: {
            value,
        },
    });
};

export const setListItemState = (
    context: IDialogProps,
    isAdd: boolean,
    item: IListItem,
    otherParams?: { [key: string]: any },
) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.UPDATE_DATA_SELECTED,
        payload: {
            item,
            isAdd,
            otherParams,
        },
    });
};

export const updateListItemState = (context: IDialogProps, item: IListItem) => {
    const dispatch = context.dispatch;
    dispatch({
        type: DIALOG_ACTION_TYPE.UPDATE_SELECTED,
        payload: {
            item,
        },
    });
};

export const setListState = (
    context: IDialogProps,
    result: { data: IListItem[]; pInfo?: any }[],
    departmentId: string,
    otherParams: { [key: string]: any },
) => {
    const dispatch = context.dispatch;
    const [department = { data: [] }, member = { data: [] }] = result;

    dispatch({
        type: DIALOG_ACTION_TYPE.SET_DATALIST,
        payload: {
            otherParams,
            memberList: member.data,
            currDepartmentId: departmentId,
            departmentList: department.data,
            pInfo: !department.pInfo ? null : department.pInfo,
        },
    });
};
